import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ValidatePolicy, ValidationResponse } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface ValidateVertiRelationsParams extends DefaultHttpHeaders {}

@Injectable()
export class ValidateVertiRelationsService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  // tslint:disable max-line-length
  /**
   * Validate Verti policy
   * Validate Verti policy. If policy is active, validInd is *true*. If policy is inactive, validInd is *false*
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Application%20Utilities/postValidateVertiRelations
   */
  validateVertiRelations(body: ValidatePolicy, params: ValidateVertiRelationsParams): Observable<ValidationResponse> {
    return this.post<ValidatePolicy, ValidationResponse>({
      body,
      suffix: '/comeround/applicationUtilities/validateVertiRelations',
    });
  }
}
